<template>
  <div class="app-container">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'AppContainer',
};
</script>

<style scoped>
</style>